let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cwzeb")).then(() => parcelRequire('guIeK'));